import { OrderFormSides } from '../../../types/OrderFormSides';
import { ButtonVariants } from '../../Button';

export function getVariant(side: OrderFormSides) {
  switch (side) {
    case OrderFormSides.Buy: {
      return ButtonVariants.Positive;
    }
    case OrderFormSides.Sell: {
      return ButtonVariants.Negative;
    }
    case OrderFormSides.Twoway: {
      return ButtonVariants.Primary;
    }
  }
}
